import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Offcanvas } from 'react-bootstrap';
import './candidateHeader.css';
import logo from '../../../assets/images/Leaderly_TM.png';
import sidelogo from '../../../assets/images/TradeMark_Logo.png';
import { decodeJWT } from '../../../services/candidateService';
import { CandidateService } from '../../../services/candidateService';
import { Link, NavLink, useLocation } from 'react-router-dom';
import bellnotify from '../../../assets/images/notification_bell.png';
import { useState, useEffect } from 'react';
import LogoutPopup from '../../content-panes/logout/logout';
// import Notifications from '../../clients/client-dashboard/client-notifications/clientNotification';
import Notification from '../../notification/notification';
import fallbackProfileLogo from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { useCandidateUser } from '../candidateUserContext/candidateUserContext';
const CandidateHeader = (props) => {
  const { candidate } = useCandidateUser();
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeLink, setActiveLink] = useState('/candidate/profile');
  const [showResources, setShowResources] = useState(false);
  const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1274 && showSidebar) {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showSidebar]);

  const location = useLocation();


  useEffect(() => {
    setRenderKey((prevKey) => prevKey + 1);

    switch (location.pathname) {
      case '/navbar-faq':
      case '/resources-blog':
      case '/policy':
      case '/pricing-prelogin':
      case '/contact-us':
      case '/about-us':
        setActiveLink('resources');
        setShowResources(true);
        break;
      case '/blogdetails':
        setActiveLink('resources');
        setShowResources(true);
        break;
      case '/candidate/dashboard':
        setActiveLink('/candidate/dashboard');
        setShowResources(false);
        break;
      case '/candidate/profile':
        setActiveLink('/candidate/profile');
        setShowResources(false);
        break;
      case '/candidate/jobs':
        setActiveLink('/candidate/jobs');
        setShowResources(false);
        break;
      case '/candidate/value-add':
        setActiveLink('/candidate/value-add');
        setShowResources(false);
        break;
      case '/candidate/psychometric-test/dashboard':
        setActiveLink('/candidate/psychometric-test/dashboard');
        setShowResources(false);
        break;
      case '/candidate/details':
        setActiveLink('/candidate/details');
        setShowResources(false);
        break;
      case '/candidate/password-reset':
        setActiveLink('/candidate/password-reset');
        setShowResources(false);
        break;
      default:
        setActiveLink('/candidate/profile');
        setShowResources(false);
        break;
    }
  }, [location.pathname]);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setShowResources(link === 'resources');
    setShowSidebar(false);
  };
  const handleSidebarClose = () => {
    setShowSidebar(false);
    const navbarCollapse = document.getElementById("navbar-nav");
    if (navbarCollapse) {
      navbarCollapse.classList.remove("show");
    }
  };

  const handleSidebarShow = () => setShowSidebar(true);
  const toggleResources = () => {
    setActiveLink('resources');
    setShowResources(!showResources);
  };

  const openLogoutPopup = () => setIsLogoutPopupVisible(true);
  const closeLogoutPopup = () => setIsLogoutPopupVisible(false);

  const logout = async () => {
    await CandidateService.logout();
    localStorage.removeItem('authToken');
    window.location.href = '/';
  };
  return (
    <div key={renderKey}>
      <BootstrapNavbar expand="lg" className="client-navbar">
        <Container className="d-flex justify-content-between align-items-center" style={{ maxWidth: '1300px' }}>
          <div className="d-flex align-items-center">
            <BootstrapNavbar.Toggle aria-controls="navbar-nav" onClick={handleSidebarShow} />
            <BootstrapNavbar.Brand href="#">
              <img src={logo} alt="Logo" className="client-navbar-logo" />
            </BootstrapNavbar.Brand>
          </div>
          <div className="d-flex align-items-center">
            <BootstrapNavbar.Collapse id="candidate-navbar-nav" className="justify-content-end">
              <Nav className="candidate-nav-links">
                {/* <Nav.Link
                  as={Link}
                  to="/candidate/dashboard"
                  className={`client-nav-link ${activeLink === '/candidate/dashboard' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('client/dashboard');
                    sessionStorage.clear();

                  }}
                >
                  Dashboard
                </Nav.Link> */}

                <Nav.Link
                  as={Link}
                  to="/candidate/profile"
                  className={`candidate-nav-link ${activeLink === '/candidate/profile' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('/candidate/profile');
                    sessionStorage.clear();
                  }}
                >
                  My Profile
                </Nav.Link>
                <Nav.Link
                  href="/candidate/jobs"
                  className={`candidate-nav-link ${activeLink === '/candidate/jobs' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('/candidate/jobs');
                    sessionStorage.clear();
                  }}
                >
                  Top Jobs
                </Nav.Link>

                <Nav.Link
                  href="/candidate/value-add"
                  className={`candidate-nav-link ${activeLink === '/candidate/value-add' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('/candidate/value-add');
                    sessionStorage.clear();
                  }}
                >
                  Career Guidance
                </Nav.Link>

                <Nav.Link
                  href="/candidate/psychometric-test/dashboard"
                  className={`candidate-nav-link ${activeLink === '/candidate/psychometric-test/dashboard' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('/candidate/psychometric-test/dashboard');
                    sessionStorage.clear();
                  }}
                >
                  Assessments
                </Nav.Link>
                <NavDropdown
                  title={
                    <span className={`candidate-nav-link ${activeLink === 'resources' ? 'client-active-link' : ''}`}>
                      Resources
                    </span>
                  }
                  className="candidate-nav-link"
                  onClick={() => {
                    handleLinkClick('resources');
                    sessionStorage.clear();
                  }}
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/about-us"
                    className={`client-dropdown-link ${location.pathname === '/about-us' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    About Us
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item
                    as={Link}
                    to="/policy"
                    className={`client-dropdown-link ${location.pathname === '/policy' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Policy
                  </NavDropdown.Item> */}
                  <NavDropdown.Item
                    as={Link}
                    to="/resources-blog"
                    className={`client-dropdown-link ${location.pathname === '/resources-blog' || location.pathname === '/blogdetails' ? 'client-active-dropdown-link' : ''

                      }`}
                  >
                    Blog
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/navbar-faq"
                    className={`client-dropdown-link ${location.pathname === '/navbar-faq' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    FAQ
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item
                    as={Link}
                    to="/pricing-prelogin"
                    className={`client-dropdown-link ${location.pathname === '/pricing-prelogin' || location.pathname === '/contact-sales' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Pricing
                  </NavDropdown.Item> */}
                  <NavDropdown.Item
                    as={Link}
                    to="/contact-us"
                    className={`client-dropdown-link ${location.pathname === '/contact-us' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Contact Us
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </BootstrapNavbar.Collapse>
            <div className="client-nav-item">
              {/* <img
                src={bellnotify}
                alt="bellnotify"
                className="bell-notify"
                onClick={() => setShowNotif(!showNotif)}
              />
              {showNotif && <Notification setShowNotif={setShowNotif} />} */}
              <div className="profile-container">

                <img
                  src={candidate?.imageBlobUrl || fallbackProfileLogo}

                  className="profile-logo"
                  onError={(e) => (e.target.src = fallbackProfileLogo)}
                /></div>

              <div className="client-nav-info">
                <div className="client-nav-name">
                  <NavDropdown
                    id="signite-nav-dropdown1"
                    title={
                      <span className="client-nav-text">{candidate?.name}</span>
                    }
                    style={{ padding: 0 }}
                  >
                    <NavDropdown.Item href="/candidate/details"
                      className={`client-dropdown-item ${location.pathname === '/candidate/details' ? 'active' : ''}`}
                    >
                      My Details
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/candidate/password-reset"
                      className={`client-dropdown-item ${location.pathname === '/candidate/password-reset' ? 'active' : ''}`}
                    >
                      Reset Password
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="#"
                      onClick={openLogoutPopup}
                      className="client-dropdown-item"
                    >
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </BootstrapNavbar>
      <LogoutPopup
        isVisible={isLogoutPopupVisible}
        variant="test"
        onTakeTest={() => window.location.href = '/candidate/psychometric-test/dashboard'}
        onClose={closeLogoutPopup}
        onConfirm={logout}
      />

      <Offcanvas show={showSidebar} onHide={handleSidebarClose} placement="start" className="client-sidebar">
        <Offcanvas.Header closeButton>
          <img src={sidelogo} alt="Logo" className="client-sidebar-logo" />
        </Offcanvas.Header>
        <hr className="client-sidebar-divider" />
        <Offcanvas.Body className="d-flex flex-column">
          <Nav className="flex-column align-items-start w-100">
            <div className="client-sidebar-link-container">
              {/* <Nav.Link
                href="#dashboard"
                className={`client-sidebar-link ${activeLink === 'dashboard' ? 'client-active-sidebar-link' : ''
                  }`}
                onClick={() => {handleLinkClick('dashboard');
                  sessionStorage.clear();
                }
                }
              >
                Dashboard
              </Nav.Link> */}
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/candidate/profile"
                className={`client-sidebar-link ${activeLink === '/candidate/profile' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => {
                  handleLinkClick('/candidate/profile');
                  sessionStorage.clear();
                }
                }
              >
                My Profile
              </Nav.Link>
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/candidate/jobs"
                className={`client-sidebar-link ${activeLink === '/candidate/jobs' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => handleLinkClick('/candidate/jobs')}
              >
                Top Jobs
              </Nav.Link>
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/candidate/value-add"
                className={`client-sidebar-link ${activeLink === '/candidate/value-add' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => handleLinkClick('/candidate/value-add')}
              >
                Value Add
              </Nav.Link>
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/candidate/psychometric-test/dashboard"
                className={`client-sidebar-link ${activeLink === '/candidate/psychometric-test/dashboard' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => handleLinkClick('/candidate/psychometric-test/dashboard')}
              >
                Assessments
              </Nav.Link>
            </div>
            <div
              className={`client-sidebar-link resources-link ${activeLink === 'resources' ? 'client-active-sidebar-link' : ''
                }`}
              onClick={() => {
                sessionStorage.clear();
                toggleResources();
              }}
            >
              Resources <span className="resources-client-arrow">{showResources ? '^' : '>'}</span>
            </div>
            {showResources && (
              <div className="client-resources-dropdown">
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={`client-sidebar-link ${location.pathname === '/about-us' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/about-us')}

                >
                  About Us
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/policy"
                  className={`client-sidebar-link ${location.pathname === '/policy' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/policy')}

                >
                  Policy
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/resources-blog"
                  className={`client-sidebar-link ${location.pathname === '/resources-blog' || location.pathname === '/blogdetails' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/resources-blog')}

                >
                  Blog
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/navbar-faq"
                  className={`client-sidebar-link ${location.pathname === '/navbar-faq' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/navbar-faq')}

                >
                  FAQ
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/pricing-prelogin"
                  className={`client-sidebar-link ${location.pathname === '/pricing-prelogin' || location.pathname === 'contact-sales' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/pricing-prelogin')}

                >
                  Pricing
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className={`client-sidebar-link ${location.pathname === '/contact-us' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/contact-us')}

                >
                  Contact Us
                </Nav.Link>
              </div>
            )}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};
export default CandidateHeader;